import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { IPage } from "@zaeper/communication-lib";
import {
  IAppVersionRestClient
} from "../../../../rest-clients/application-version/app-version/i-app-version-rest.client";
import {
  appVersionRestClientInjectionToken
} from "../../../../rest-clients/application-version/app-version/app-version-rest-client-injection-token";
import { IAppVersion } from "../../../../models/application-version/i-app-version";

@Injectable()
export class AppVersionPageResolver implements Resolve<IPage<IAppVersion>> {
  constructor(@Inject( appVersionRestClientInjectionToken ) private readonly _appVersionRestClient: IAppVersionRestClient) {
  }

  resolve(route: ActivatedRouteSnapshot): Promise<IPage<IAppVersion>> {
    const appId: string | null = route.paramMap.get( 'appId' );

    if ( appId === null ) {
      return Promise.reject();
    }

    return this._appVersionRestClient.getAppVersionPage( appId, {
      pageNumber: 0,
      pageSize: 100
    } );
  }
}
